import { cn } from '@crehana/compass.ui/utils';

type TEnrollmentsCourseContainerCardProps = {
  title: string;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const EnrollmentsCourseContainerCard: React.FC<
  React.PropsWithChildren<TEnrollmentsCourseContainerCardProps>
> = ({ title, children, className, ...divProps }) => {
  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-w-full tw-rounded-1.6 tw-shadow-02 tw-bg-neutral-light-100',
        className,
      )}
      {...divProps}
    >
      <h2 className="tw-font-subtitle5 tw-px-2.4 tw-py-1.6 tw-border-b tw-border-solid tw-border-neutral-light-400">
        {title}
      </h2>
      <div className="tw-px-2.4 tw-pt-1.6 tw-pb-2.4">{children}</div>
    </div>
  );
};
